// @flow

import type { State } from '../reducers';

type GlobalState = {
  formSettings: State,
};

export const getFormSettings = (state: GlobalState): State => {
  const { formSettings } = state;
  if (!formSettings) {
    throw new Error('Missing formSettings store.');
  }
  return formSettings;
};

export const getLabels = (state: GlobalState) => {
  const formSettings = getFormSettings(state);
  const exclude = ['errorMessages'];
  return Object.keys(formSettings).filter(key => !exclude.includes(key))
    .reduce((acc, key) => ({
      ...acc,
      [key.valueOf()]: formSettings[key],
    }), {});
};

export const hasShops = (state: GlobalState) => getFormSettings(state).shops.length > 0;

export default null;
